import { h } from 'preact';
import * as BaseComp from '<%SRC_DIR%>/components/shared/footer/footer.js';
import s from 'components/shared/footer/footer.sss';
import { Link } from 'components/core/link/link';

export default class Footer extends BaseComp.default {

	getStudioLink() {
		let appData = this.props.appData;
		let { footer, studio } = appData;
		return (
			<div class={s.studioLinkWrapper}>
				<Link
					class={s.studio}
					trackId="ccoc-logo"
					href="/"
					target="_blank"
					renderCustomChild
				>
					<img src={appData.urls.roots.image + '/legal-logos.png'} alt="CCoC" />
				</Link>
				<Link
					class={s.studio}
					trackId="trafalgar-logo"
					href="https://www.facebook.com/TheCreativeCoalitionofColor"
					target="_blank"
					renderCustomChild
				>
					<img src={appData.urls.roots.image + '/facebook_white.png'} alt="Facebook" />
				</Link>
        <Link
          class={s.studio}
          trackId="instagram-logo"
          href="https://www.instagram.com/creativecoalitionofcolor/"
          target="_blank"
          renderCustomChild
        >
          <img src={appData.urls.roots.image + '/instagram_white.png'} alt="Instagram" />
        </Link>
        <Link
          class={s.studio}
          trackId="linkedIn-logo"
          href="https://www.linkedin.com/company/thecreativecoalitionofcolor/about/"
          target="_blank"
          renderCustomChild
        >
          <img src={appData.urls.roots.image + '/linkedin_white.png'} alt="LinkedIn" />
        </Link>
        <Link
          class={s.studio}
          trackId="twitter-logo"
          href="https://twitter.com/TheCCofColor"
          target="_blank"
          renderCustomChild
        >
          <img src={appData.urls.roots.image + '/twitter_white.png'} alt="Twitter" />
        </Link>
			</div>
		);
	}

}

export const dependencies = BaseComp.dependencies;
